import request from '@/utils/request2'

// 下载痕迹化资料文档（单个文件）
export function downloadTraceDocumentApi (data) {
  return request({
    url: 'tms-web/dataTemplate/downloadTraceDocument',
    method: 'post',
    data
  })
}

// 打包下载痕迹化资料文档
export function downloadTraceDocumentByZipApi (data) {
  return request({
    url: 'tms-web/dataTemplate/downloadTraceDocumentByZip',
    method: 'post',
    data
  })
}

// 零星物料制作申报审批表下载
export function downloadMaterialsMakeDeclarationApi (data) {
  return request({
    url: 'tms-web/dataTemplate/materialsMakeDeclarationDownload',
    method: 'post',
    data
  })
}

// 导出方案培训记录表
export function exportTrainingRecordDataApi (data) {
  return request({
    url: 'tms-web/dataTemplate/exportTrainingRecord',
    method: 'post',
    data
  })
}

// 导出方案据实结算清单
export function downloadSchemeTrulySettleApi (data) {
  return request({
    url: 'tms-web/dataTemplate/schemeTrulySettleDownload',
    method: 'post',
    data
  })
}

// 导出方案活动执行质量问题清单
export function downloadSchemeActivityWarningInfoApi (data) {
  return request({
    url: 'tms-web/dataTemplate/schemeActivityWarningInfoDownload',
    method: 'post',
    data
  })
}
